module.exports = __webpack_public_path__ + "static/media/nikita.1a955df8.webp";